import styled from 'styled-components';
import { CustomButton } from '@mindly/ui-components';

export const CardFormWrapper = styled.div`
  padding: 0px 16px;
`;

export const CardFormTitle = styled.div`
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  color: #1d201f;
  margin-bottom: 16px;
`;

export const SavedCardsTitle = styled.div`
  font-size: 12px;
  line-height: 14px;
  color: #5b5b5b;
  margin-bottom: 10px;
`;

export const SavedCardsWrapper = styled.div`
  margin-bottom: 25px;
`;

export const NewCardButton = styled.button`
  margin-top: 25px;
  outline: none;
  background: transparent;
  font-size: 16px;
  line-height: 18px;
  color: #177590;
  display: flex;
  align-items: center;
  column-gap: 7px;
  margin-bottom: 26px;

  & span {
    width: 15px;
    height: 15px;
    border: 1.25px solid #177590;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    line-height: 0;
    padding-bottom: 1.5px;
  }
`;

export const NewCardTitle = styled.div`
  font-size: 12px;
  line-height: 14px;
  color: #5b5b5b;
  margin-bottom: 16px;
`;

export const PaymentInfoWrapper = styled.div`
  margin-top: 16px;
  font-size: 12px;
  line-height: 14px;
  color: #5b5b5b;
  display: flex;
  flex-direction: column;
  row-gap: 16px;
`;

export const PaymentInfoRow = styled.div`
  display: flex;
  column-gap: 8.56px;
  align-items: center;

  &:last-child {
    align-items: center;
  }

  & ion-icon {
    flex-shrink: 0;
    font-size: 18px;
  }

  & .lock-icon {
    color: #26b183;
  }

  & .clock-icon {
    color: #c13e18;
  }

  & .checkmark-icon {
    color: #26b183;
  }
`;

export const PaymentButton = styled(CustomButton)`
  height: 47px !important;
  font-size: 18px !important;

  &:disabled {
    background: #eeeeee !important;
    color: #c1c1c1 !important;
  }
`;
